<script setup>
import { isEmpty } from 'lodash';
import { computed } from 'vue';
import ListaObjetosConEstructura from '@/models/estructura_escolar/ListaObjetosConEstructura';
import CheckboxesGrupos from './CheckboxesGrupos.vue';

const props = defineProps({
  inputName: { type: String, default: null },
  // Objetos grupo con los objetos de la estructura escolar (ensennanza, nivel, curso, etc.)
  grupos: { type: Array, required: true },
});

const ensennanzas = computed(() => {
  if (!Array.isArray(props.grupos)) return [];

  const gruposHash = props.grupos.map((grupo) => ({
    ...grupo,
    grupo: { id: grupo.id, nombre: grupo.nombre, etiqueta: grupo.etiqueta },
  }));

  const listaEstructura = new ListaObjetosConEstructura(gruposHash);

  return listaEstructura.arbolEstructuraEscolar
    .map((anno) => anno.ensennanzas)
    .flat();
});
</script>

<template>
  <div id="acordeon-grupos" class="panel-group">
    <div
      v-for="(ensennanza, idx) in ensennanzas"
      :key="idx"
      class="panel panel-default"
    >
      <div
        :id="`heading-${ensennanza.id}`"
        class="panel-heading"
        data-toggle="collapse"
        :data-parent="'#acordeon-grupos'"
        :data-target="`#collapse-${ensennanza.id}`"
        aria-expanded="false"
        :aria-controls="`collapse-${ensennanza.id}`"
        style="cursor: pointer;"
      >
        <h3 class="panel-title">
          {{ ensennanza.nombre }}
        </h3>
      </div>
      <div
        :id="`collapse-${ensennanza.id}`"
        class="panel-collapse collapse"
        :aria-labelledby="`heading-${ensennanza.id}`"
      >
        <div class="panel-body">
          <CheckboxesGrupos
            :titulo="ensennanza.nombre"
            :grupos="ensennanza.grupos"
            :input-name="`${inputName}[]`"
          />
          <div
            v-for="nivel in ensennanza.niveles"
            :key="nivel.id"
            class="nivel-section"
          >
            <h4>{{ nivel.nombre }}</h4>
            <CheckboxesGrupos
              :titulo="nivel.nombre"
              :grupos="nivel.grupos"
              :input-name="`${inputName}[]`"
            />
            <div
              v-for="curso in nivel.cursos"
              :key="curso.id"
              class="curso-section"
            >
              <h5 v-if="isEmpty(curso.grupos)">
                {{ curso.nombre }}
              </h5>
              <CheckboxesGrupos
                :titulo="curso.nombre"
                :grupos="curso.grupos"
                :input-name="`${inputName}[]`"
              />
              <li v-for="modalidad in curso.modalidades" :key="modalidad.id">
                <h6>{{ modalidad.nombre }}</h6>
                <CheckboxesGrupos
                  :titulo="modalidad.nombre"
                  :grupos="modalidad.grupos"
                  :input-name="`${inputName}[]`"
                />
              </li>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
